export const USER_SEGMENTS_LIST_TABS = {
    USER_SEGMENT: "User segments",
    ATTRIBUTES: "Attributes"
}
